<script>
export default {
  name: 'ImageProduct',
  props: {
    product: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      default: 'w-full'
    }
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_API_URL
    }
  }
}
</script>

<template>
  <div v-if="product.Images" class="lg:-translate-x-1/3 z-10">
    <img v-if="product.Images[0]" class="w-[36rem] h-auto object-cover rounded-lg" :src="`${apiUrl}${product.Images[0].url}`" alt="Image produit" />
  </div>
</template>
